'use client';

import BDButton from '@shared/components/elements/button';
import { setFilterUrlFilterChoice } from '@shared/lib/utils/url-utils';
import clsx from 'clsx';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
const PageButton = ({
  page,
  currentPage,
  lastPage,
  onPageChange,
}: {
  page: number;
  currentPage: number;
  lastPage: number;
  onPageChange: (page: number) => void;
}) => {
  // if (page === currentPage) {
  //   return <span className="underline">{page}</span>;
  // }

  const displayPage =
    page === 1 || page === lastPage
      ? page
      : Math.abs(page - currentPage) > 2 && Math.min(page - 1, lastPage - page) > 1
        ? '...'
        : page;

  return (
    <BDButton
      styleType="noBorder"
      onClick={() => onPageChange(page)}
      className={clsx('text-base font-normal', page === currentPage && 'underline')}
    >
      {displayPage}
    </BDButton>
  );
};

export const Pagination = ({
  currentPage,
  totalPages,
}: {
  currentPage: number;
  totalPages: number;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const handlePageChange = (page: number) => {
    setFilterUrlFilterChoice(router, pathname, searchParams, 'page', page.toString(), true, true);
  };

  const hasPreviousPage = currentPage > 1;
  const hasNextPage = currentPage < totalPages;
  const p = currentPage;
  const pages = Array.from(
    new Set(
      [
        1,
        Math.floor(p / 2),
        p - 2,
        p - 1,
        p,
        p + 1,
        p + 2,
        Math.floor((p + totalPages) / 2 + 1),
        totalPages,
      ].filter((p) => p > 0 && p <= totalPages)
    )
  );

  return (
    <div className="flex flex-row flex-wrap items-center gap-2">
      <h4 className="text-nowrap text-base font-normal">Pages:</h4>
      <BDButton
        styleType="noBorder"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={!hasPreviousPage}
        className="text-md font-normal"
      >
        {'<'}
      </BDButton>
      {pages.map((page) => (
        <PageButton
          key={page}
          page={page}
          currentPage={currentPage}
          lastPage={totalPages}
          onPageChange={handlePageChange}
        />
      ))}
      <BDButton
        styleType="noBorder"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={!hasNextPage}
        className="text-md font-normal"
      >
        {'>'}
      </BDButton>
    </div>
  );
};

export const LoadMoreButton = ({
  currentPage,
  totalPages,
}: {
  currentPage: number;
  totalPages: number;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  if (currentPage >= totalPages) {
    return null;
  }

  return (
    <BDButton
      styleType="secondary"
      className="bg-bd-contrast w-full px-16 py-2 md:w-auto"
      onClick={() => {
        setFilterUrlFilterChoice(
          router,
          pathname,
          searchParams,
          'page',
          (currentPage + 1).toString(),
          true,
          true
        );
      }}
    >
      Load Next Page
    </BDButton>
  );
};
